
export default function ToggleButton({ leftLabel, rightLabel, onChange, checked, className }) {
  const [_checked, setChecked] = useState(checked)
  const onClick = () => {
    setChecked(!_checked)
    onChange(!_checked)
  }

  return <div className={ cn('flex shadow rounded-full overflow-hidden', className) } onClick={ onClick }>
    <div className='relative text-[0.85rem] cursor-pointer py-2 w-1/2 text-center'>
      <div className={ cn('bg-gray-700 absolute rounded-full top-0 bottom-0 left-0 right-0', { hidden: checked }) } />
      <div className={ cn('relative', { 'text-white': !checked }) }>
        {leftLabel}
      </div>
    </div>
    <div className={ cn('relative text-[0.85rem] cursor-pointer py-2 w-1/2 text-center') }>
      <div className={ cn('bg-gray-700 absolute rounded-full top-0 bottom-0 left-0 right-0', { hidden: !checked }) } />
      <div className={ cn('relative', { 'text-white': checked }) }>
        {rightLabel}
      </div>
    </div>
  </div>
}
